<template>
  <div class="w-full">
    <div class="flex items-center">
      <h2 class="text-lg font-normal text-left">
        {{ $t('manager.discoverCommunityContent') }}
      </h2>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
